




































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import KoejaksonVaiheHyvaksynnat from '@/components/koejakson-vaiheet/koejakson-vaihe-hyvaksynnat.vue'
import { KoulutussopimusLomake, KoejaksonVaiheHyvaksynta } from '@/types'
import * as hyvaksynnatHelper from '@/utils/koejaksonVaiheHyvaksyntaMapper'

@Component({
  components: {
    KoejaksonVaiheHyvaksynnat
  }
})
export default class KoulutussopimusReadonly extends Vue {
  @Prop({ required: true, default: {} })
  data!: KoulutussopimusLomake

  get hyvaksynnat(): KoejaksonVaiheHyvaksynta[] {
    const hyvaksyntaErikoistuva = hyvaksynnatHelper.mapHyvaksyntaErikoistuva(
      this,
      this.data.erikoistuvanNimi,
      this.data.erikoistuvanAllekirjoitusaika
    ) as KoejaksonVaiheHyvaksynta
    const hyvaksynnatKouluttajat = hyvaksynnatHelper.mapHyvaksynnatSopimuksenKouluttajat(
      this.data.kouluttajat
    ) as KoejaksonVaiheHyvaksynta[]
    const hyvaksyntaVastuuhenkilo = hyvaksynnatHelper.mapHyvaksyntaVastuuhenkilo(
      this.data.vastuuhenkilo
    ) as KoejaksonVaiheHyvaksynta

    return [hyvaksyntaErikoistuva, ...hyvaksynnatKouluttajat, hyvaksyntaVastuuhenkilo].filter(
      (a): a is KoejaksonVaiheHyvaksynta => a !== null
    )
  }
}
